import "./App.css";
import Event from "./Components/Event/Event";
import Category from "./Components/Category/Category";
import Certificate from "./Components/Certificate/Certificate";
import CertificateVerification from "./Components/Certificate/CertificateVerification";
import AdminDashboard from "./Components/Admin/AdminDashboard";
import UserDashboard from "./Components/User/UserDashboard";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import { Layout } from "./Components/layout";
import { PageNotFound } from "./Components/NotFound404";
import MyToast from "./Components/Toast";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { Loader } from "./Components/Loader";
import { APIRequestProvider } from "./context";
import Login from "./Components/login";
import Register from "./Components/register";
import Logout from "./Components/logout";
import { RouteGuard } from "./Components/RouteGuard";
import { setAuthToken, getAuthToken } from "./lib/apiService";
import { useEffect } from "react";

function App() {
  // Initialize auth token on app load
  useEffect(() => {
    const token = getAuthToken();
    if (token) {
      setAuthToken(token);
    }
  }, []);

  function hasJWT() {
    return getAuthToken() ? true : false;
  }

  function isAdmin() {
    const user = localStorage.getItem("user");
    if (user) {
      try {
        const userData = JSON.parse(user);
        return userData.role === "admin";
      } catch (e) {
        return false;
      }
    }
    return false;
  }

  return (
    <APIRequestProvider>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route
            path="/login"
            element={hasJWT() ? <Navigate to="/dashboard" /> : <Login />}
          />
          <Route
            path="/register"
            element={hasJWT() ? <Navigate to="/dashboard" /> : <Register />}
          />
          <Route 
            path="/verify/:certificateId" 
            element={<CertificateVerification />} 
          />
          <Route 
            path="/verify" 
            element={<CertificateVerification />} 
          />
          <Route path="/logout" element={<Logout />} />

          {/* Protected Routes */}
          <Route
            path="/"
            element={
              <RouteGuard>
                <Layout />
              </RouteGuard>
            }
          >
            {/* Admin Routes (always defined; gated per element) */}
            <Route
              path="admin"
              element={isAdmin() ? <AdminDashboard /> : <Navigate to="/dashboard" />}
            />
            <Route
              path="categories"
              element={isAdmin() ? <Category /> : <Navigate to="/dashboard" />}
            />
            <Route
              path="events"
              element={isAdmin() ? <Event /> : <Navigate to="/dashboard" />}
            />
            <Route
              path="events/:category_id"
              element={isAdmin() ? <Event /> : <Navigate to="/dashboard" />}
            />
            <Route
              path="certificates/:category_id/:event_id"
              element={isAdmin() ? <Certificate /> : <Navigate to="/dashboard" />}
            />
            
            {/* User Routes */}
            <Route path="dashboard" element={<UserDashboard />} />
            <Route path="my-certificates" element={<UserDashboard />} />
            
            {/* Default Route */}
            <Route
              index
              element={
                hasJWT() ? (
                  isAdmin() ? (
                    <Navigate to="/categories" />
                  ) : (
                    <Navigate to="/dashboard" />
                  )
                ) : (
                  <Navigate to="/verify" />
                )
              }
            />
          </Route>
          
          {/* 404 Route */}
          <Route
            path="*"
            element={hasJWT() ? <PageNotFound /> : <Navigate to="/verify" />}
          />
        </Routes>

        <MyToast />
        <Loader />
      </Router>
    </APIRequestProvider>
  );
}

export default App;
